import script from "./studentProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./studentProfile.vue?vue&type=script&setup=true&lang=js"

import "./studentProfile.vue?vue&type=style&index=0&id=676bf58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676bf58a"]])

export default __exports__